export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-regular-820034a0ab5aa039ef94fadaf6849ae2.woff2";